import { selectSellViaExAgentRebateIdsByBillingSettingsIdLookup } from "./indexes";
import { createLookupCombiner, createLookupSelectors } from "./lib";
import { getSellViaExAgentRebates } from "./root";

export const [
  selectDeploymentSellViaExAgentRebatesByBillingSettingsIdLookup,
  getDeploymentSellViaExAgentRebatesByBillingSettingsId,
] = createLookupSelectors(
  [
    selectSellViaExAgentRebateIdsByBillingSettingsIdLookup,
    getSellViaExAgentRebates,
  ],
  createLookupCombiner(
    (
      rebateIds: string[],
      rebatesByIdLookup: StateModelById<SellViaExAgentRebate>,
    ) => rebateIds.map(rebateId => rebatesByIdLookup[rebateId]),
  ),
);
